import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{on:{"click":function($event){$event.preventDefault();return _vm.sortBy.apply(null, arguments)}}},[_vm._t("default"),(_vm.isOrderedBy && !_vm.isDesc)?_c(VIcon,{staticClass:"pl-2",attrs:{"small":"","color":"primary-color"}},[_vm._v(" caret-up ")]):(_vm.isOrderedBy && _vm.isDesc)?_c(VIcon,{staticClass:"pl-2 mt-n1",attrs:{"small":"","color":"primary-color"}},[_vm._v(" caret-down ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }